import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Book, BookStatus } from "./book.model";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class LibraryService {
    url = `${environment.libraryURL}/api/v1/books`;

    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<FindAllBooksInPortOutput>(this.url);
    }

    create(formData: FormData) {
        return this.http.post<CreateBookOutput>(this.url, formData);
    }

    delete(id: string) {
        return this.http.delete(`${this.url}/${id}`);
    }
}

// export interface BookSummary {
//     id: string;
//     originalFilename: string;
//     title: string | null;
//     authors: string[];
//     edition: string | null;
//     status: BookStatus;
//     totalPages: number | null;
//     totalChunks: number;
//     createdAt: Date;
//     updatedAt: Date;
// }

export interface FindAllBooksInPortOutput {
    items: Book[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

export interface CreateBookOutput {
    id: string;
    original_filename: string;
    status: BookStatus;
    storedPdfUri: string | null;
    createdAt: Date;
}
